import { computed, ComputedRef } from 'vue'
import Cookies from 'js-cookie'
import { CookieName } from '@/config/cookies'

export function useCompanyChecks(): {
  isCSE: ComputedRef<boolean>
  isCOSOG: ComputedRef<boolean>
  companyName: ComputedRef<string | undefined>
} {
  /**
   * Get the company name from the cookie
   */
  const companyName = computed(() => {
    return Cookies.get(CookieName.COMPANY)
  })

  /**
   * Check if CSE - true if there is a company cookie
   */
  const isCSE = computed(() => {
    return !!companyName.value
  })

  /**
   * Check if CGOS - true if the company cookie has value 'cogos'
   */
  const isCOSOG = computed(() => {
    return companyName.value === 'cosog'
  })

  return {
    isCSE,
    isCOSOG,
    companyName,
  }
}
